import Resource from '@/plugins/sdk/Resource'
import { DATETIME, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'report'

  static get fields () {
    return {
      id: new UUID(),
      date_from: new DATETIME(),
      date_to: new DATETIME()
    }
  }
}
